import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {DiscountService} from '../service-discount/discount.service';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {DiscountModel} from '../../../../models/DiscountModel';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-new-discount',
  templateUrl: './new-discount.component.html',
  styleUrls: ['./new-discount.component.scss']
})
export class NewDiscountComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  anagrafInSettings: boolean;

  discount: DiscountModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  providerSelect: ProviderModel;
  saveDiscount: Subscription;

  showLC: boolean;
  showRegion: boolean;
  showDiscount: boolean;
  showProvider: boolean;
  registerForm: FormGroup;
  submitted = false;

  allYear: any;
  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private discountService: DiscountService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.anagrafInSettings = true;
    this.showLC  = false;
    this.showRegion  = false;
    this.showDiscount = false;
    this.showProvider = false;
    this.discount = new DiscountModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.providerSelect = new ProviderModel();

  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      discount: [{value: '', disabled: false}, Validators.required],
      anno: [{value: '', disabled: false}, Validators.required]
    });

    this.getAllYear();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.discount.discount = this.registerForm.value.discount;
      this.discount.numAnno = this.registerForm.value.anno;
      event.preventDefault();
      this.loaderService.display(true);
      this.saveDiscount = this.discountService.save(this.discountService.baseUrl, this.discount)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Discount was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
            }
          },
          error => {
            toastr.error('Discount was not created', 'Error');
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveDiscount) {
      this.saveDiscount.unsubscribe();
    }
  }

  getElementSelectedRegion($event) {
    this.discount.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });


  }

  getElementSelectedLC($event) {
    this.discount.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedProvider($event) {
    this.discount.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });


  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  handle(value) {
    this.discount.numAnno = value;
    this.registerForm.patchValue({
      anno: value
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }

  resetAll() {
    this.showLC = false;
    this.showRegion = false;
    this.showProvider = false;
    this.regionSelect = null;
    this.localCustomerSelect = null;
    this.providerSelect = null;
  }

  resetTables() {
    this.registerForm.patchValue({
      region: ''
    });
    this.registerForm.patchValue({
      localCustomerCod: ''
    });

    this.registerForm.patchValue({
      provider: ''
    });

    this.resetAll();
  }

  hideTables() {
    this.showRegion = false;
    this.showLC = false;
    this.showProvider = false;
  }
}
